import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Header2_ScreenProvider } from "../screens/header2/header2-context";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { GetData_Screen } from "../screens/getdata/getdata";
import { ProductSearch_Screen } from "../screens/productsearch/productsearch";
import { WarehouseTransferDetail_Screen } from "../screens/warehousetransferdetail/warehousetransferdetail";
import { AddBasketPopUp_Screen } from "../screens/addbasketpopup/addbasketpopup";
import { ProductSelect_Screen } from "../screens/productselect/productselect";
import { BasketReports_Screen } from "../screens/basketreports/basketreports";
import { AddBasketBarcodePopUp_Screen } from "../screens/addbasketbarcodepopup/addbasketbarcodepopup";
import { CustomerDetail_Screen } from "../screens/customerdetail/customerdetail";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { OrderSummary_Screen } from "../screens/ordersummary/ordersummary";
import { WarehouseTransferAddManuelItemPop_Screen } from "../screens/warehousetransferaddmanuelitempop/warehousetransferaddmanuelitempop";
import { CustomerSelect_Screen } from "../screens/customerselect/customerselect";
import { BasketReportsDetail_Screen } from "../screens/basketreportsdetail/basketreportsdetail";
import { PaymentPlan_Screen } from "../screens/paymentplan/paymentplan";
import { StockCountInfo_Screen } from "../screens/stockcountinfo/stockcountinfo";
import { StockCountList_Screen } from "../screens/stockcountlist/stockcountlist";
import { Gul_Screen } from "../screens/gul/gul";
import { PaymentScreen_Screen } from "../screens/paymentscreen/paymentscreen";
import { ProductBasket_Screen } from "../screens/productbasket/productbasket";
import { WarehouseTransferHeader_Screen } from "../screens/warehousetransferheader/warehousetransferheader";
import { UserCreate_Screen } from "../screens/usercreate/usercreate";
import { Bosekran_Screen } from "../screens/bosekran/bosekran";
import { Authentication_Sign_In_Screen } from "../screens/authentication_sign_in/authentication_sign_in";
import { AuthScreen_Screen } from "../screens/authscreen/authscreen";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { UserEdit_Screen } from "../screens/useredit/useredit";
import { WarehouseTransferList_Screen } from "../screens/warehousetransferlist/warehousetransferlist";
import { Signup_Screen } from "../screens/signup/signup";
import { ProductSearchInfo_Screen } from "../screens/productsearchinfo/productsearchinfo";
import { Signin_Screen } from "../screens/signin/signin";
import { ProductDetail_Screen } from "../screens/productdetail/productdetail";
import { UserManagement_Screen } from "../screens/usermanagement/usermanagement";
import { StockCountDetail_Screen } from "../screens/stockcountdetail/stockcountdetail";
import { WarehouseTransferInfo_Screen } from "../screens/warehousetransferinfo/warehousetransferinfo";
import { StockCountDetailEdit_Screen } from "../screens/stockcountdetailedit/stockcountdetailedit";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { Header2_Screen } from "../screens/header2/header2";
import { StockCountHeader_Screen } from "../screens/stockcountheader/stockcountheader";
import { Furkan_Screen } from "../screens/furkan/furkan";
import { CustomerDetailReport_Screen } from "../screens/customerdetailreport/customerdetailreport";
import { UserRoleManagement_Screen } from "../screens/userrolemanagement/userrolemanagement";
import { StockAddManuelItemCountPop_Screen } from "../screens/stockaddmanuelitemcountpop/stockaddmanuelitemcountpop";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { CustomerHeaderReport_Screen } from "../screens/customerheaderreport/customerheaderreport";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";

class Header2_Screen_Wrapper extends MasterScreenWrapper {
  protected get anonymousPaths(): string[] { return []; }
  protected get MasterComponent(): React.ComponentType<any> { return Header2_Screen; }
  protected get MasterProvider(): React.ComponentType<any> { return Header2_ScreenProvider; }
  protected renderSwitchWrapper(): React.ReactNode {
    return (
      <Switch>
        <PrivateRoute exact path="/productsearch" component={ProductSearch_Screen} />
        <PrivateRoute exact path="/warehousetransferdetail" component={WarehouseTransferDetail_Screen} />
        <PrivateRoute exact path="/productselect" component={ProductSelect_Screen} />
        <PrivateRoute exact path="/basketreports" component={BasketReports_Screen} />
        <PrivateRoute exact path="/customerdetail" component={CustomerDetail_Screen} />
        <PrivateRoute exact path="/ordersummary" component={OrderSummary_Screen} />
        <PrivateRoute exact path="/customerselect" component={CustomerSelect_Screen} />
        <PrivateRoute exact path="/basketreportsdetail" component={BasketReportsDetail_Screen} />
        <PrivateRoute exact path="/stockcountlist" component={StockCountList_Screen} />
        <PrivateRoute exact path="/paymentscreen" component={PaymentScreen_Screen} />
        <PrivateRoute exact path="/productbasket" component={ProductBasket_Screen} />
        <PrivateRoute exact path="/warehousetransferheader" component={WarehouseTransferHeader_Screen} />
        <PrivateRoute exact path="/warehousetransferlist" component={WarehouseTransferList_Screen} />
        <PrivateRoute exact path="/productsearchinfo" component={ProductSearchInfo_Screen} />
        <PrivateRoute exact path="/productdetail" component={ProductDetail_Screen} />
        <PrivateRoute exact path="/stockcountdetail" component={StockCountDetail_Screen} />
        <PrivateRoute exact path="/stockcountheader" component={StockCountHeader_Screen} />
        <PrivateRoute exact path="/customerdetailreport" component={CustomerDetailReport_Screen} />
        <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
        <PrivateRoute exact path="/customerheaderreport" component={CustomerHeaderReport_Screen} />
      </Switch>
    );
  }
}



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
                        <PrivateRoute exact path="/" component={AuthScreen_Screen} />
                        <Route path={["/productsearch", "/warehousetransferdetail", "/productselect", "/basketreports", "/customerdetail", "/ordersummary", "/customerselect", "/basketreportsdetail", "/stockcountlist", "/paymentscreen", "/productbasket", "/warehousetransferheader", "/warehousetransferlist", "/productsearchinfo", "/productdetail", "/stockcountdetail", "/stockcountheader", "/customerdetailreport", "/homepage", "/customerheaderreport"]} component={Header2_Screen_Wrapper} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/getdata" component={GetData_Screen} />
            <PrivateRoute exact path="/addbasketpopup" component={AddBasketPopUp_Screen} />
            <PrivateRoute exact path="/addbasketbarcodepopup" component={AddBasketBarcodePopUp_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/warehousetransferaddmanuelitempop" component={WarehouseTransferAddManuelItemPop_Screen} />
            <PrivateRoute exact path="/paymentplan" component={PaymentPlan_Screen} />
            <PrivateRoute exact path="/stockcountinfo" component={StockCountInfo_Screen} />
            <PrivateRoute exact path="/gul" component={Gul_Screen} />
            <PrivateRoute exact path="/usercreate" component={UserCreate_Screen} />
            <PrivateRoute exact path="/bosekran" component={Bosekran_Screen} />
            <Route exact path="/authentication_sign_in" component={this.LoginComponent()} />
            <Route exact path="/authentication_sign_in" component={Authentication_Sign_In_Screen} />
            <PrivateRoute exact path="/authscreen" component={AuthScreen_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <PrivateRoute exact path="/useredit" component={UserEdit_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <Route exact path="/signin" component={Signin_Screen} />
            <PrivateRoute exact path="/usermanagement" component={UserManagement_Screen} />
            <PrivateRoute exact path="/warehousetransferinfo" component={WarehouseTransferInfo_Screen} />
            <PrivateRoute exact path="/stockcountdetailedit" component={StockCountDetailEdit_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/furkan" component={Furkan_Screen} />
            <PrivateRoute exact path="/userrolemanagement" component={UserRoleManagement_Screen} />
            <PrivateRoute exact path="/stockaddmanuelitemcountpop" component={StockAddManuelItemCountPop_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    // The host injects external_access_token as a short-lived MFE handoff JWT.
    // No refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Authentication_Sign_In_Screen;
    }
    return <></>;
  };
}
